<wdpr-modal 
    #confirmCancelModal 
    hide-close-icon 
    disable-close-on-background
    close
>
    <h3 slot="title" class="header">Are you sure you want to exit?</h3>
    <wdpr-button class="default me-0 ms-0" slot="buttons" theme="primary" (click)="onProceed()">YES</wdpr-button>
    <wdpr-button class="default me-2 ms-0" slot="buttons" theme="secondary" (click)="close()">NO</wdpr-button>
</wdpr-modal>
